import React, { Component } from "react";
import { FilesInfo } from "../shared/Files";

class Files extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filesInfo: FilesInfo,
      selectedSection: null,
    };
  }

  selectSection(sectionId) {
    this.setState({
      selectedSection: this.state.filesInfo[sectionId]
    });
  }

  goBack() {
    this.setState({
      selectedSection: null
    });
  }

  render() {

    const sections = this.state.filesInfo.map((section) => {
      return(
        <a className="btn mb-3 section-btn" href="#" key={section.id} onClick={() => this.selectSection(section.id)}>{section.name}</a>
      );
    });

    if (this.state.selectedSection == null) {
      window.scrollTo(0, 0)
    return (
      <div className="d-flex flex-column my-auto justify-convent-center align-items-center" style={{"backgroundColor": "#fafafa"}}>
        <h2 className="page-title d-flex py-3">Файлы и материалы для скачивания</h2>
        <div className="sections sections-main container-fluid d-flex pt-3">{sections}</div>
      </div>
    );
  }
    else {
      window.scrollTo(0, 0)
    return(
      <div className="d-flex flex-column my-auto justify-convent-center align-items-center" style={{"backgroundColor": "#fafafa"}}>
      <h2 className="page-title d-flex py-3">{this.state.selectedSection.name}</h2>
      <div style={{"width":"100%"}} className="sections pt-3">
      <a className="btn file-btn mb-3 ml-md-5 ml-3" href="#" onClick={() => this.goBack()}>Назад</a>
      <SectionFiles files={this.state.selectedSection.files} sectionName={this.state.selectedSection.name}/>
      </div>
    </div>
    );
  }
  }
}

class SectionFiles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      files: this.props.files,
      sectionName: this.props.sectionName,
    }
  }


  render() {

    const renderFiles = this.state.files.map((file, index) => {
      return (
        <RenderOneFile
          key={file.id}
          id={index+1}
          name={file.name}
          extension={file.extension}
          size={file.size}
          section={this.state.sectionName}
        />
      );
    });

    if (renderFiles.length !== 0)
    return(
      <div>{renderFiles}</div>
    );
    else
    return(
      <div className="no-files d-flex">
        <p>
          <i className="fa fa-file-o"/>
          <i className="fa fa-times"/>
        </p>
        <h3>Файлов в данной секции нет</h3>
      </div>
    );
  }
}

const icons = {
  ".txt": "fa-file-text-o",
  ".doc": "fa-file-word-o",
  ".docx": "fa-file-word-o",
  ".pdf": "fa-file-pdf-o",
  ".pptx": "fa-file-powerpoint-o",
  ".ppsx": "fa-file-powerpoint-o",
  ".ppt": "fa-file-powerpoint-o",
};

class RenderOneFile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.id,
      name: props.name,
      extension: props.extension,
      size: props.size,
      section: props.section,
    };
  }

  render() {
    const id = this.state.id;
    const name = this.state.name;
    const extension = this.state.extension;
    const size = this.state.size;
    const path = "./assets/files/" + this.state.section + "/" + name + extension;
    const icon = icons[extension] ?? "fa-file-o";

    return (
      <div className="ml-lg-5 mx-auto mx-md-0 mr-0 row mb-3 align-items-center file">
        <div className="mt-3 col-md-9 col-lg-10">
          <div className="ml-md-5">
          <div className="row align-items-center">
            <p className="file-icon mb-xs-0 mb-md-3"><i className={"fa ml-3 mr-2 mr-md-4 " + icon}/></p>
            <h4>
              {/* {id}&nbsp; */}
              {name.split('_').join(' ')}</h4>
          </div>
          <div className="row info">
              <p className="ml-2">{extension}</p>&nbsp;&nbsp;
              <p>Размер: {size}</p>
          </div>
          </div>
        </div>
        <div className="col-md-3 col-lg-2 mb-3 mb-md-0 dwn-div">
        <a download className="btn-lg download-btn" href={path} target="_blank" rel="noopener noreferrer">Скачать</a></div>
      </div>
    );
  }
}

export default Files;
